<template>
  <div class="body-inner">
    <div class="modal-dim" v-show-modal-alert>
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner center">
          <div class="modal">
            <div class="modal-con">
              <div class="modal-txt">
                <div class="txt-ttl">
                  <h6 class="confirm_title">{{ title }}</h6>
                </div>
                <div class="txt-con">
                  <p>
                    {{ text }}
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-btn">
              <div class="btn-wrap">
                <button class="btn yd-cta yd-cta--primary" @click="confirm">
                  {{ confirmText }}
                </button>

                <button
                  class="btn yd-cta yd-cta--secondary"
                  @click="reject"
                >
                  {{ rejectText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineEmits,
  defineProps,
  getCurrentInstance,
  onMounted,
  toRefs
} from 'vue';

const { proxy } = getCurrentInstance();
const { data } = defineProps({
  data: {
    type: [Object],
    default: () => {}
  }
});
const emits = defineEmits({
  close: {
    type: [Function],
    default: () => {}
  }
});
const { text, confirmText, rejectText, title } = toRefs(data);
const { confirmCallback } = data;

onMounted(() => {});

const confirm = () => {
  if (confirmCallback) confirmCallback();
  proxy.$emit('close');
};
const reject = () => {
  // if (callBackCancel) callBackCancel();
  proxy.$emit('close');
};
</script>

<style scoped>
.confirm_title {
  font-weight: bolder;
  margin-bottom: 1rem;
}
</style>
